import { FC } from 'react';

import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import ToolCard from 'components/ToolCard';
import Button from '@mui/material/Button';

const DepartureLocationsCard: FC = () => (
  <ToolCard
    icon={<FlightTakeoffIcon fontSize="large" />}
    title="Išvykimo vietos"
    description="Išvykimo vietų redagavimas"
    action={
      <Button
        href="departure-locations"
        startIcon={<FlightTakeoffIcon />}
        size="small">
        Redaguoti
      </Button>
    }
  />
);

export default DepartureLocationsCard;
